import React from 'react';
import * as S from './styles';
import logoProfiz from "assets/icons/logo-profiz.svg";
export function LoadingPageModal() {
    return (<S.Container>
        <img src={logoProfiz} alt="logo animado da profiz" />
    </S.Container>);
}